const ticketcategory = {
  getlist: 'ticketcategory/getlist',
  add: 'ticketcategory/add',
  update: 'ticketcategory/update',
  remove: 'ticketcategory/remove',
  get: 'ticketcategory/get',
  getall: 'ticketcategory/getall',
  clearcache: 'ticketcategory/clear-cache',
}
export default ticketcategory
